import FooterBottom from "@components/Footer/FooterComponents/FooterBottom";
import FooterTop from "@components/Footer/FooterComponents/FooterTop";

/** This is the main footer of BT that appears in all pages. */
export default function Footer(): React.ReactElement {
  return (
    <div
      data-testid="footer-container"
      id="footer-container"
      className="no-print antialiased"
    >
      <FooterTop />
      <FooterBottom />
    </div>
  );
}
